/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './contact-us.stache';
import can from 'can';
import chosen from 'vendors/chosen/chosen.jquery.min';

const latestPagePath = window.globalSettings.pagePaths.latest;

Component.extend({
    tag: 'contact-us',
    template,
    leakScope: false,
    viewModel: {
        submitted: false,
        latestPagePath: latestPagePath,
        define: {
            fields: {
                Type: can.Map,
            },
            faq: {
                Type: can.Map,
            },
            formOptions: {
                Type: can.Map,
            },
            defaultEmailAddr: {
                type: 'string',
            },
            data: {
                Type: can.Map,
                value: new can.Map({
                    emailTarget: {
                        value: '',
                        errors: [],
                    },
                    fullName: {
                        value: null,
                        errors: [],
                    },
                    email: {
                        value: null,
                        errors: [],
                    },
                    country: {
                        value: 'United States',
                        errors: [],
                    },
                    subject: {
                        value: null,
                        errors: [],
                    },
                    message: {
                        value: '',
                        errors: [],
                    },
                }),
            },
            errors: {
                Type: can.List,
                get() {
                    let usedTypes = [];
                    let errors = [];
                    this.attr('data').each((item) => {
                        item.attr('errors').each((error) => {
                            if (usedTypes.indexOf(error.type) == -1) {
                                usedTypes.push(error.type);
                                errors.push(error);
                            }
                        });
                    });
                    return errors;
                },
            },
        },
        isRequired(field) {
            let isRequired = false;
            field.validators.forEach((validator) => {
                isRequired = isRequired || validator.type === 'required';
            });
            return isRequired;
        },
        setData(key, element) {
            let value = element.value;
            if (key === 'message') {
                const maxLength = this.attr('fields.message.length');
                value = element.value.substr(
                    0,
                    maxLength > value.length ? value.length : maxLength,
                );
                if (maxLength < value.length) {
                    element.value = value;
                }
            }
            if (key === 'subject') {
                this.attr(
                    `data.emailTarget.value`,
                    btoa(
                        can
                            .$(element)
                            .find('option:selected')
                            .attr('data-email-target') || '',
                    ),
                );
            }
            this.attr(`data.${key}.value`, value);
        },
        getLengthDiff(from, to) {
            return from.length - to.length;
        },
    },
    events: {
        inserted() {
            this.element.find('.s-form-field__select .dropdown').chosen({
                width: '100%',
            });
            this.viewModel.attr(
                'data.emailTarget.value',
                btoa(this.viewModel.attr('defaultEmailAddr')),
            );

            this.element.find('.s-form-field__textarea').val('');
        },

        'form submit'(element, event) {
            event.preventDefault();
            let hasErrors = false;
            this.viewModel.attr('fields').each((options, key) => {
                let fieldErrors = [];
                options.validators.each((validator) => {
                    const result = validator.validate(
                        this.viewModel.attr(`data.${key}.value`),
                    );
                    if (!result.valid) {
                        hasErrors = true;
                        fieldErrors.push({
                            type: validator.type,
                            message: result.message,
                        });
                    }
                });
                this.viewModel.attr(`data.${key}.errors`, fieldErrors);
            });
            if (!hasErrors) {
                const formData = element.serializeArray();
                formData.map((field) => {
                    if (field.name === 'Message' && window.navigator) {
                        field.value = [
                            field.value,
                            'UserAgent: ' + window.navigator.userAgent,
                        ].join('\n\n');
                    }
                });
                can.ajax({
                    type: 'POST',
                    url: this.viewModel.attr('formOptions.action'),
                    data: formData,
                    complete: () => {
                        this.viewModel.attr('submitted', true);
                    },
                });
            }
        },
    },
});
